import { OfferData } from '@wwe-portal/entities/offer.type';

export function requiresWebCoin(offer: OfferData | Partial<OfferData>) {
  return (
    offer.OfferType === 'AlternativeCurrency' &&
    offer.AlternativeCostAmount !== undefined
  );
}

export function getOfferPrice(offer: OfferData) {
  if (requiresWebCoin(offer)) {
    return `${offer.AlternativeCostAmount}`;
  } else if (offer.regionalPrice) {
    const price = offer.regionalPrice.formatted;
    return price.amount;
  } else {
    return `${offer.Price?.USD}`;
  }
}

export function getOfferStrikethroughPrice(offer: OfferData) {
  if (requiresWebCoin(offer)) {
    return undefined;
  } else if (offer.regionalPrice) {
    const price = offer.regionalPrice.formatted;
    return price.amountNoDiscount;
  } else {
    return offer.StrikeThroughPrice
      ? String(offer.StrikeThroughPrice)
      : undefined;
  }
}

export function getNumericOfferPrice(offer: OfferData): number | undefined {
  if (requiresWebCoin(offer)) {
    return offer.AlternativeCostAmount;
  } else if (offer.regionalPrice) {
    const price = offer.regionalPrice.raw;
    return price.amount ? Number(price.amount) : undefined;
  } else {
    return offer.Price?.USD;
  }
}
